exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// E:/Learning/Git-Other/SWOF/SWOF.UI/node_modules/core-js/modules/_object-gops.js
// module id = ../../../../core-js/modules/_object-gops.js
// module chunks = polyfills